/**
 * @generated SignedSource<<1d20eb02df6d13de8bc0c45ce17a5e99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type deleteTagInput = {
  clientMutationId?: string | null;
  id: string;
};
export type deleteAcademiesTagButton_DeleteTagMutation$variables = {
  connections: ReadonlyArray<string>;
  input: deleteTagInput;
};
export type deleteAcademiesTagButton_DeleteTagMutation$data = {
  readonly Admin: {
    readonly AcademiesTag: {
      readonly deleteTag: {
        readonly deletedId: string;
      } | null;
    };
  };
};
export type deleteAcademiesTagButton_DeleteTagMutation = {
  response: deleteAcademiesTagButton_DeleteTagMutation$data;
  variables: deleteAcademiesTagButton_DeleteTagMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteAcademiesTagButton_DeleteTagMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagAdminMutationSchema",
            "kind": "LinkedField",
            "name": "AcademiesTag",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "deleteTagPayload",
                "kind": "LinkedField",
                "name": "deleteTag",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deleteAcademiesTagButton_DeleteTagMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagAdminMutationSchema",
            "kind": "LinkedField",
            "name": "AcademiesTag",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "deleteTagPayload",
                "kind": "LinkedField",
                "name": "deleteTag",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedId",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb7b83e9f655a3fe801e2c4e88632f91",
    "id": null,
    "metadata": {},
    "name": "deleteAcademiesTagButton_DeleteTagMutation",
    "operationKind": "mutation",
    "text": "mutation deleteAcademiesTagButton_DeleteTagMutation(\n  $input: deleteTagInput!\n) {\n  Admin {\n    AcademiesTag {\n      deleteTag(input: $input) {\n        deletedId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f869714abf21bbe11438d5f640b59bb0";

export default node;
